import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import PopUps from "./PopUps.vue";
import { inject } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkingProccesSection',
  setup(__props) {

const store:any = inject(`store`);
const dataArray = store.getters.getWorkingProccesDataArray;

return (_ctx: any,_cache: any) => {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_SectionHeader, {
      title: "Our Working Process",
      text: "Step-by-Step Guide to Achieving Your Business Goals"
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataArray), (popUp) => {
      return (_openBlock(), _createBlock(PopUps, {
        key: popUp.number,
        number: popUp.number,
        title: popUp.title,
        description: popUp.description
      }, null, 8, ["number", "title", "description"]))
    }), 128))
  ]))
}
}

})